module.exports = __webpack_public_path__ + "static/email/img/icon_access.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_access.png
// module id = Bxih
// module chunks = 1